export enum Colors {
  red = 'red',
  pink = 'pink',
  purple = 'purple',
  deepDurple = 'deepPurple',
  indigo = 'indigo',
  blue = 'blue',
  lightBlue = 'lightBlue',
  cyan = 'cyan',
  teal = 'teal',
  green = 'green',
  lightGreen = 'lightGreen',
  lime = 'lime',
  yellow = 'yellow',
  amber = 'amber',
  orange = 'orange',
  deepOrange = 'deepOrange',
  brown = 'brown',
  grey = 'grey',
  blueGrey = 'blueGrey',
}

export enum AgeGroupType {
  neo = 'Neo',
  pediatric = 'Pediatric',
  adults = 'Adults',
}

export interface AgeGroup {
  ageGroupId: string;
  name: string;
  type: AgeGroupType;
  maxAge: number;
  maxWeight: number;
  color: Colors;
  observations?: string;
}

export type ItemView = AgeGroup;
